import React, { useEffect, useCallback, useContext, } from 'react';
import { getItemId, listData } from '@react-aria/listbox';
import { omit } from '../../utils/index.js';
import { FilterInput } from './select.styles.js';
import { getNextItemKey, getPreviousItemKey, isSection } from './utils.js';
import { SelectContext } from './use-select-state.js';
export const SelectFilterInputComponent = () => {
    const { props, state } = useContext(SelectContext).selectState;
    const { filterInput, dataAutomation } = props;
    const { listState, selectedItems, listId, setCachedSelectedItems, setUncontrolledFilterValue, setFilterActiveDescendant, filterActiveDescendant, buttonState, } = state;
    const { selectionManager } = listState;
    useEffect(() => {
        if (!listData.has(listState))
            return;
        setFilterActiveDescendant(getItemId(listState, selectionManager.focusedKey));
    }, [selectionManager.focusedKey]);
    const onKeyDown = useCallback((e) => {
        switch (e.key) {
            case 'Enter': {
                const item = listState.collection.getItem(selectionManager.focusedKey);
                if (item?.value &&
                    !isSection(item.value) &&
                    item.value.variant === 'none') {
                    selectionManager.clearSelection();
                }
                else {
                    selectionManager.toggleSelection(selectionManager.focusedKey);
                }
                break;
            }
            case 'ArrowDown': {
                e.preventDefault();
                const nextKey = getNextItemKey(selectionManager.focusedKey, listState.collection);
                selectionManager.setFocused(true);
                if (nextKey) {
                    selectionManager.setFocusedKey(nextKey);
                }
                else {
                    selectionManager.setFocusedKey(listState.collection.getFirstKey());
                }
                break;
            }
            case 'ArrowUp': {
                e.preventDefault();
                const prevKey = getPreviousItemKey(selectionManager.focusedKey, listState.collection);
                selectionManager.setFocused(true);
                if (prevKey) {
                    selectionManager.setFocusedKey(prevKey);
                }
                else {
                    selectionManager.setFocusedKey(listState.collection.getLastKey());
                }
                break;
            }
            default:
                break;
        }
    }, [listState, selectionManager]);
    const onFilterChange = useCallback((value) => {
        setCachedSelectedItems(selectedItems);
        filterInput?.onDebouncedChange?.(value);
        setUncontrolledFilterValue(value);
    }, [
        filterInput?.onDebouncedChange,
        setUncontrolledFilterValue,
        setCachedSelectedItems,
        selectedItems,
    ]);
    useEffect(() => {
        if (!buttonState.isOpen) {
            onFilterChange('');
        }
    }, [buttonState.isOpen]);
    return filterInput ? (React.createElement(FilterInput, { variant: 'search', label: filterInput.placeholder, hiddenLabel: true, onKeyDown: onKeyDown, debounceTime: filterInput?.debounceTime || 'standard', onDebouncedChange: onFilterChange, dataAutomation: `${dataAutomation}/filter`, ...omit(filterInput, 'onDebouncedChange'), "aria-controls": listId, "aria-activedescendant": filterActiveDescendant })) : null;
};
//# sourceMappingURL=select-filter-input.component.js.map